import React, { useContext, createContext, useState } from "react";

const PopupContext = createContext();

const PopupProvider = ({ children }) => {
  const [catchUser, setCatchUser] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userClosedModal, setUserClosedModal] = useState(false);
  return (
    <PopupContext.Provider
      value={{
        catchUser,
        setCatchUser,
        userEmail,
        setUserEmail,
        userClosedModal,
        setUserClosedModal,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
};

export const usePopupContext = () => {
  return useContext(PopupContext);
};

export { PopupContext, PopupProvider };
